import React, { Component, PropTypes } from 'react';

import './CollapsiblePanel.scss';

export default class CollapsiblePanel extends Component {
  static propTypes = {
    label: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    startClosed: PropTypes.bool,
  };

  static defaultProps = {
    startClosed: false,
  };

  componentWillMount() {
    const { startClosed } = this.props;
    this.setState({
      isOpen: !startClosed,
    });
  }

  handleLabelClick = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    const { label, children } = this.props;
    const { isOpen } = this.state;

    const modifier = isOpen ? 'open' : 'closed';

    return (
      <div className="collapsible-panel">
        <button className={`collapsible-panel__label collapsible-panel__label--${modifier}`} onClick={this.handleLabelClick}>{label}</button>
        <div className={`collapsible-panel__content collapsible-panel__content--${modifier}`}>
          { children }
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CollapsiblePanel/CollapsiblePanel.jsx
 **/